import React from "react";
import { Link } from "react-router-dom";
import "./GuideHeader.css";
import aiFallback from "../../assets/ai-section-fallback.png";

const GuideHeader = ({ headingLevel = "h1" }) => {
  const HeadingTag = headingLevel;

  return (
    <section className="guide-header">
      <HeadingTag className="guide-header-title">The Mailsnappy guide to email marketing</HeadingTag>

      <div className="guide-header-cards">
        {/* 🟢 Getting Started */}
        <Link to="/gettingstarted" className="header-card link-card">
          <span className="icon">❄️</span>
          <h3>Getting started</h3>
          <p>The 10 do’s and don’ts of email marketing</p>
        </Link>

        {/* 🟣 Sending your first email */}
        <div className="header-card center-card">
          <img
            src={aiFallback}
            alt="Mailsnappy"
            className="octo-icon"
          />
          <h3>Sending your first email</h3>
          <Link to="/GuideSubjectLines">
            <p>Writing a great subject line</p>
          </Link>
          <Link to="/GuideEffectiveEmail">
            <p>How to write an effective email</p>
          </Link>
        </div>

        {/* 🔵 Taking it to the next level */}
        <div className="header-card">
          <span className="icon">📈</span>
          <h3>Taking it to the next level</h3>
          <Link to="/GuidePersonalising">
            <p>Personalising your campaigns</p>
          </Link>
          <Link to="/GuideScheduling">
            <p>Scheduling your campaigns</p>
          </Link>
          <Link to="/GuideMeasureSuccess">
            <p>Measuring the success of your emails</p>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GuideHeader;
